import i18n from '@/i18n';
import formatDate from '@/services/general/formatDate';
import formatBackToLineHtml from '@/services/general/formatBackToLineHtml';
import { ETAT_OBTENU } from '@/configuration/optionBlocage/optionBlocage';
import calculDaysBetweenTwoDate from '@/services/general/calculDaysBetweenTwoDate';
import { REGROUPEMENT, NORMAL } from '@/configuration/devisConf';
import {
  CATEGORIE_REGROUPEMENT_NUMERIQUE,
  CATEGORIE_ECRAN_NUMERIQUE,
  CATEGORIE_REGROUPEMENT_LC,
  CATEGORIE_REGROUPEMENT,
  CATEGORIE_UNITAIRE,
  CATEGORIE_LOCATION,
  CATEGORIE_DIVERS, CATEGORIE_SALON, CATEGORIE_SPONSORING, CATEGORIE_AUTRE, CATEGORIE_PRESSE,
  CATEGORIE_DISPOSITIF,
} from '@/configuration/catalogue/produitConf';
import store from '@/store/store';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';

function getLibelleOptionBlocage(ligne, isEtatSouhaite) {
  const statusOfLigne = isEtatSouhaite ? ligne.etatSouhaite : ligne.etatObtenu;
  if (!isEtatSouhaite && ligne.etatDeLaDemande) return 'optionBlocage.attenteReponse';
  return ETAT_OBTENU.find((status) => {
    return status.key === statusOfLigne;
  }).libelle;
}

function addCommentaire(commentaireAssocie) {
  let commentaireAAfficher = '<br>';
  commentaireAssocie.forEach((commentaire) => {
    commentaireAAfficher += `<small>${commentaire.libelle}</small><br>`;
  });
  return commentaireAAfficher;
}

function getDescriptionReseauTempo(ligneEnfant, ligne, type, commentaireAssocie) {
  let description = `<strong class="table__label-produit"> ${ligne.libelle}</strong><br>
    <small> - ${i18n.t('detail.descriptionLigneCommande.semaine')}${ligne.ligneReseau.anneeSemaine.toString().substr(4)} - ${i18n.t('detail.descriptionLigneCommande.du')} ${formatDate(ligne.dateDebut)} ${i18n.t('detail.descriptionLigneCommande.au')} ${formatDate(ligne.dateFin)}</small>`;

  if (ligne.produit.produitReseau.format) {
    description += `<small> - ${ligne.produit.produitReseau.format.libelle}</small>`;
  }

  description += `<br><small>${i18n.t('detail.descriptionLigneCommande.nbFaces')} ${ligne.ligneReseau.qteFacesSouhaitees}</small>`;

  if (type === 'Devis') {
    description += `<small class="is-prewrap is-word-break"> - ${i18n.t('optionBlocage.detail.souhaite')} ${i18n.t(getLibelleOptionBlocage(ligne, true))} - ${i18n.t('optionBlocage.detail.obtenu')} ${i18n.t(getLibelleOptionBlocage(ligne, false))} </small>`;
    if (ligne.rangOption && !ligne.etatDeLaDemande) {
      description += `<small class="is-prewrap is-word-break"> - ${i18n.t('optionBlocage.detail.rang')} ${ligne.rangOption}</small>`;
    }
  }

  description += `<small> - ${ligneEnfant.libelle} </small>`;
  description += addCommentaire(commentaireAssocie);
  return description;
}

function getDescriptionFace(ligneEnfant, ligne, commentaireAssocie) {
  let description = `
    <strong class="table__label-produit"> ${ligne.libelle}</strong><br>
    <small> - ${formatDate(ligne.dateDebut)} ${i18n.t('detail.descriptionLigneCommande.au')} ${formatDate(ligne.dateFin)} - ${Number(calculDaysBetweenTwoDate(ligne.dateFin, ligne.dateDebut)) + 1} ${i18n.t('detail.descriptionLigneCommande.jours')} - ${ligneEnfant.libelle}</small>`;

  if (ligne.quantiteDispo !== 1) { description += `<small> - ${i18n.t('detail.descriptionLigneCommande.surface')} ${ligne.quantiteDispo * 100}%`; }

  description += addCommentaire(commentaireAssocie);
  return description;
}

function getDescriptionDivers(ligneEnfant, ligne, commentaireAssocie) {
  let description = `<strong class="table__label-produit"> ${ligne.libelle}</strong><br>
    <small> - ${ligneEnfant.libelle}</small>`;
  description += addCommentaire(commentaireAssocie);
  return description;
}

function getDescriptionSalon(ligneEnfant, ligne, commentaireAssocie) {
  let description = `
    <strong class="table__label-produit"> ${ligne.libelle}</strong><br>
    <small>
  `;
  if (ligne.numStand) description += ` - ${i18n.t('detail.descriptionLigneCommande.stand', { num: ligne.numStand })}`;
  if (ligne.surface) description += ` - ${i18n.t('detail.descriptionLigneCommande.size', { size: ligne.surface })}`;
  description += '</small>';
  description += `<small>${ligneEnfant.libelle}</small>`;
  description += addCommentaire(commentaireAssocie);
  return description;
}

function getDescriptionPresse(ligneEnfant, ligne, commentaireAssocie) {
  let description = `
    <strong class="table__label-produit"> ${ligne.libelle}</strong><br>
  `;
  if (ligne.parution) {
    description += `<a target="_blank" class="lien" href="/detailParution/${ligne.parution.id}">`;
    description += `<small> - ${i18n.t('detail.descriptionLigneCommande.parution', {
      code: ligne.parution.nomParution,
      date: formatDate(ligne.dateDebut),
    })}`;
    description += '</small></a>';
  }
  description += `<small> - ${formatBackToLineHtml(ligneEnfant.libelle)}</small>`;
  description += addCommentaire(commentaireAssocie);
  return description;
}

function getDescriptionSponsoring(ligneEnfant, ligne, commentaireAssocie) {
  let description = `<strong class="table__label-produit">${ligne.produit.reference} - ${ligne.libelle}</strong>`;
  if (ligne.dateDebut) description += `<small> - ${formatDate(ligne.dateDebut)}`;
  if (ligne.dateFin) description += ` ${i18n.t('detail.descriptionLigneCommande.au')} ${formatDate(ligne.dateFin)} `;
  description += '</small><br>';
  description += `<small>${ligneEnfant.libelle}</small>`;
  description += addCommentaire(commentaireAssocie);
  return description;
}

function getDescriptionAutre(ligneEnfant, ligne, commentaireAssocie) {
  let description = `<strong class="table__label-produit">${ligne.produit.reference} - ${ligne.libelle}</strong>`;
  description += '<br>';
  description += `<small>${ligneEnfant.libelle}</small>`;
  description += addCommentaire(commentaireAssocie);
  return description;
}

function getDescriptionReseauLc(ligneEnfant, ligne, commentaireAssocie) {
  let description = `<strong class="table__label-produit"> ${ligne.libelle}</strong><br>
    <small> - ${formatDate(ligne.dateDebut)} ${i18n.t('detail.descriptionLigneCommande.au')} ${formatDate(ligne.dateFin)} - ${ligneEnfant.libelle}</small>`;
  if (ligne.quantiteDispo !== null && ![0, 1].includes(ligne.quantiteDispo)) {
    description += `<small> - ${i18n.t('detail.descriptionLigneCommande.vente', { value: ligne.quantiteDispo * 100 })}`;
  }
  description += addCommentaire(commentaireAssocie);
  return description;
}

function getDescriptionBasique(ligneEnfant, ligne, commentaireAssocie) {
  let description = `<strong class="table__label-produit"> ${ligne.libelle}</strong><br>
    <small> - ${formatDate(ligne.dateDebut)} ${i18n.t('detail.descriptionLigneCommande.au')} ${formatDate(ligne.dateFin)} - ${ligneEnfant.libelle}</small>`;
  description += addCommentaire(commentaireAssocie);
  return description;
}

function getDescriptionDispositif(ligne, ligneCommandeDispositif) {
  let description = `
    <strong class="table__label-produit"> ${ligne.libelle}</strong><br>
    <small>
  `;
  if (ligneCommandeDispositif.dispositifSupportId) {
    const support = store.getters['parametres/parametre'](PARAMETRES_KEYS.dispositifSupport).find((s) => {
      return s.id === ligneCommandeDispositif.dispositifSupportId;
    })?.libelle ?? '';
    description += ` - ${i18n.t('detail.descriptionLigneCommande.dispositifSupport', { support: support })}`;
  }
  if (ligneCommandeDispositif.dispositifTypeId) {
    const typeDispositif = store.getters['parametres/parametre'](PARAMETRES_KEYS.dispositifType).find((t) => {
      return t.id === ligneCommandeDispositif.dispositifTypeId;
    })?.libelle ?? '';
    description += ` - ${i18n.t('detail.descriptionLigneCommande.typeDispositif', { type: typeDispositif })}`;
  }
  if (ligneCommandeDispositif.materielFormatId) {
    const formatMateriel = store.getters['parametres/parametre'](PARAMETRES_KEYS.materielFormat).find((f) => {
      return f.id === ligneCommandeDispositif.materielFormatId;
    })?.libelle ?? '';
    description += ` - ${i18n.t('detail.descriptionLigneCommande.format', { format: formatMateriel })}`;
  }
  if (ligneCommandeDispositif.materielTypeId) {
    const matType = store.getters['parametres/parametre'](PARAMETRES_KEYS.materielType).find((mt) => {
      return mt.id === ligneCommandeDispositif.materielTypeId;
    })?.libelle ?? '';
    description += ` - ${i18n.t('detail.descriptionLigneCommande.materielType', { materiel: matType })}`;
  }
  if (ligneCommandeDispositif.longueur && ligneCommandeDispositif.longueur !== 0) {
    description += ` - ${i18n.t('detail.descriptionLigneCommande.longueur', { long: ligneCommandeDispositif.longueur })}`;
  }
  if (ligneCommandeDispositif.largeur && ligneCommandeDispositif.largeur !== 0) {
    description += ` - ${i18n.t('detail.descriptionLigneCommande.largeur', { lag: ligneCommandeDispositif.largeur })}`;
  }
  description += ` - ${i18n.t('detail.descriptionLigneCommande.isDoubleFace', { val: ligneCommandeDispositif.isDoubleFace ? 'Oui' : 'Non' })}`;
  description += ` - ${i18n.t('detail.descriptionLigneCommande.eclaire', { val: ligneCommandeDispositif.materielEclaire ? 'Oui' : 'Non' })}`;
  description += '</small>';
  return description;
}

export default function getDescriptionOfDetailLigne(
  ligneEnfant, ligne, type, commentaireAssocie, isFirstLigne,
) {
  if (!ligneEnfant && ligne.typeProduit === CATEGORIE_LOCATION
    && ligne.dateDebut && ligne.dateFin) {
    return `<strong class="table__label-produit"> ${ligne.libelle}</strong>
    <small> - ${formatDate(ligne.dateDebut)} ${i18n.t('detail.descriptionLigneCommande.au')} ${formatDate(ligne.dateFin)}</small>`;
  }
  if (!ligneEnfant && ligne.type === NORMAL && ligne.typeProduit === CATEGORIE_DISPOSITIF) {
    return getDescriptionDispositif(ligne, ligne.ligneCommandeDispositif);
  }
  if (!ligneEnfant) return `${ligne.libelle ? ligne.libelle : ''}`;
  if (ligneEnfant.typeProduit === CATEGORIE_LOCATION && ligne.type === REGROUPEMENT
    && ligne.typeProduit === CATEGORIE_REGROUPEMENT) {
    return getDescriptionReseauTempo(ligneEnfant, ligne, type, commentaireAssocie);
  }
  if (ligneEnfant.typeProduit === CATEGORIE_LOCATION && ligne.type === REGROUPEMENT
    && ligne.typeProduit === CATEGORIE_UNITAIRE) {
    return getDescriptionFace(ligneEnfant, ligne, commentaireAssocie);
  }
  if (ligne.type === REGROUPEMENT && ligne.typeProduit === CATEGORIE_SALON) {
    return getDescriptionSalon(ligneEnfant, ligne, commentaireAssocie);
  }
  if (ligne.type === REGROUPEMENT && ligne.typeProduit === CATEGORIE_PRESSE) {
    return getDescriptionPresse(ligneEnfant, ligne, commentaireAssocie);
  }
  if (ligne.type === REGROUPEMENT && ligne.typeProduit === CATEGORIE_SPONSORING) {
    return getDescriptionSponsoring(ligneEnfant, ligne, commentaireAssocie);
  }
  if (ligne.type === REGROUPEMENT && ligne.typeProduit === CATEGORIE_AUTRE) {
    return getDescriptionAutre(ligneEnfant, ligne, commentaireAssocie);
  }
  if (ligneEnfant.typeProduit === CATEGORIE_LOCATION && ligne.type === REGROUPEMENT
    && ligne.typeProduit === CATEGORIE_REGROUPEMENT_LC) {
    return getDescriptionReseauLc(ligneEnfant, ligne, commentaireAssocie);
  }
  if (ligneEnfant.typeProduit === CATEGORIE_LOCATION && ligne.type === REGROUPEMENT
    && (ligne.typeProduit === CATEGORIE_ECRAN_NUMERIQUE
      || ligne.typeProduit === CATEGORIE_REGROUPEMENT_NUMERIQUE
      || ligne.typeProduit === CATEGORIE_REGROUPEMENT_LC)) {
    return getDescriptionBasique(ligneEnfant, ligne, commentaireAssocie);
  }
  if (ligneEnfant.typeProduit === CATEGORIE_DIVERS && ligne.type === REGROUPEMENT
    && isFirstLigne) {
    return getDescriptionDivers(ligneEnfant, ligne, commentaireAssocie);
  }
  return ` - ${ligneEnfant.libelle}`;
}
